module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'pl-4': _vm.cache.categories[_vm.categoryId] && _vm.cache.categories[_vm.categoryId].parent
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [(_vm.childCategories.length && _vm.cache.categories[_vm.categoryId]) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "btn btn-small btn-link btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_c('i', {
    class: 'fa-fw fa fa-chevron-' + (_vm.expanded ? 'down' : 'right') + ' text-muted'
  })])]) : _vm._e(), _vm._v(" "), (!_vm.childCategories.length && _vm.cache.categories[_vm.categoryId]) ? _c('div', {
    staticClass: "my-1 mx-3 pull-left"
  }) : _vm._e(), _vm._v(" "), (_vm.cache.categories[_vm.categoryId]) ? _c('div', {
    staticClass: "pull-left p-1 my-2"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.cache.categories[_vm.categoryId].name))])]) : _vm._e(), _vm._v(" "), (_vm.cache.categories[_vm.categoryId]) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-small btn-warning btn-icon edit",
    attrs: {
      "to": '/moderate/category/' + _vm.categoryId + '/edit'
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-small btn-danger btn-icon remove",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.remove(_vm.categoryId)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.childCategories), function(category) {
    return (_vm.expanded) ? [_c('category-tree', {
      attrs: {
        "category-id": category.id
      }
    })] : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08a650ea!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/admin/CategoryTree.vue
// module id = 636
// module chunks = 1